function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 21 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M1.7 0C.765 0 0 .765 0 1.7v10.2c0 .935.765 1.7 1.7 1.7h17c.935 0 1.7-.765 1.7-1.7V1.7c0-.935-.765-1.7-1.7-1.7zm8.5 2.55a4.252 4.252 0 014.25 4.25 4.252 4.252 0 01-4.25 4.25A4.252 4.252 0 015.95 6.8a4.252 4.252 0 014.25-4.25zm0 1.53a2.72 2.72 0 100 5.44 2.72 2.72 0 000-5.44zm7.65-2.38a.85.85 0 110 1.7.85.85 0 010-1.7z",
  fill: "#575757"
})));